import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  GcIconComponent,
  GcIconName,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { Observable, take } from 'rxjs';
import {
  fadeAnimation,
  growAnimation,
  listFadeAnimation,
} from '../../../shared/animations/enter-leave-animations';
import { provideTranslations } from '../../../shared/utils/translations-util';
import { UserService } from '../../api/user.service';
import { LoggedInUser, SelfserviceHubRoles } from '../../entities/user';

type MenuLink = {
  url: string;
  text: string;
  icon: GcIconName;
  requiredRoles: string[];
};

@Component({
  selector: 'app-hub-sidebar',
  imports: [CommonModule, RouterModule, IpoTranslatePipe, GcIconComponent],
  templateUrl: './hub-sidebar.component.html',
  styleUrls: ['./hub-sidebar.component.scss'],
  providers: [
    provideTranslations({
      sv: {
        addressSearch: 'Sök adress',
        userManagement: 'Hantera användare',
        groupManagement: 'Hantera grupper',
        logout: 'Logga ut',
      },
    }),
    IpoTranslatePipe,
  ],
  animations: [fadeAnimation, growAnimation, listFadeAnimation({ delay: 200 })],
})
export class HubSidebarComponent implements OnInit {
  protected links: MenuLink[] = [
    {
      url: '/adressök',
      text: this.translatePipe.transform('addressSearch'),
      icon: 'magnifyingGlass',
      requiredRoles: [],
    },
    {
      url: '/hub/user-management',
      text: this.translatePipe.transform('userManagement'),
      icon: 'users',
      requiredRoles: [
        SelfserviceHubRoles.SelfserviceAdmin,
        SelfserviceHubRoles.SelfserviceGroupAdmin,
      ],
    },
    {
      url: '/hub/group-management',
      text: this.translatePipe.transform('groupManagement'),
      icon: 'flowchart',
      requiredRoles: [SelfserviceHubRoles.SelfserviceAdmin],
    },
  ];

  public user$: Observable<LoggedInUser | undefined>;
  public activeIndex = 0;
  public expanded = false;
  public expandedHeader = false;

  constructor(
    private userService: UserService,
    private translatePipe: IpoTranslatePipe
  ) {}

  ngOnInit(): void {
    this.user$ = this.userService.getPortalUser$();
  }

  public toggle(index?: number): void {
    if (index) {
      this.activeIndex = index;
    }
    this.expanded = !this.expanded;
  }

  public toggleHeader(): void {
    this.expandedHeader = !this.expandedHeader;
  }

  public allowToSeeLink(requiredRoles: string[]): boolean {
    if (requiredRoles.length === 0) {
      return true;
    }

    let allowed = false;
    this.user$.pipe(take(1)).subscribe((user) => {
      requiredRoles.forEach((role) => {
        if (user?.roles?.includes(role)) {
          allowed = true;
        }
      });
    });

    return allowed;
  }

  public async logout(): Promise<void> {
    await this.userService.logout();
  }
}
